import { createSlice } from '@reduxjs/toolkit'
import { merge } from 'components/util'
import MediaQualityAssuranceSettings from './media-quality-assurance-settings-model'
import {
  CreateMediaQualityAssuranceSettingsAsync,
  DeleteMediaQualityAssuranceSettingsAsync,
  LoadMediaQualityAssuranceSettingssAsync,
} from './mediaQualityAssuranceSettings-thunk'
const initialState: mediaQualityAssuranceSettingsSliceState = {
  mediaQualityAssuranceSettings: [],
  selected_mediaQualityAssuranceSettings: '',
  is_loading_mediaQualityAssuranceSettings: false,
  is_creating_mediaQualityAssuranceSettings: false,
  is_deleting_mediaQualityAssuranceSettings: false,
}
export interface mediaQualityAssuranceSettingsSliceState {
  mediaQualityAssuranceSettings: MediaQualityAssuranceSettings[]
  selected_mediaQualityAssuranceSettings?: string
  is_loading_mediaQualityAssuranceSettings: boolean
  is_creating_mediaQualityAssuranceSettings: boolean
  is_deleting_mediaQualityAssuranceSettings: boolean
}
export const mediaQualityAssuranceSettingsSlice = createSlice({
  name: 'mediaQualityAssuranceSettings',
  initialState,
  reducers: {
    setSelectedmediaQualityAssuranceSettings: (state, action) => {
      state.selected_mediaQualityAssuranceSettings = action.payload
    },
    clearStatemediaQualityAssuranceSettings: (state) => {
      state.mediaQualityAssuranceSettings = []
      state.is_loading_mediaQualityAssuranceSettings = false
      state.is_creating_mediaQualityAssuranceSettings = false
      state.is_deleting_mediaQualityAssuranceSettings = false
    },
    mergemediaQualityAssuranceSettings: (state, action) => {
      if (action.payload) {
        let payload: any = action.payload
        if (payload?.data) {
          if (!Array.isArray(payload.data)) {
            state.selected_mediaQualityAssuranceSettings = payload?.data?.id
            payload = [payload.data]
          } else {
            payload = payload.data
          }
          state.mediaQualityAssuranceSettings = merge(
            state.mediaQualityAssuranceSettings,
            payload,
          ) as any
        }
      }
    },

    add_mediaQualityAssuranceSettings: (state, action) => {
      if (action.payload) {
        state.mediaQualityAssuranceSettings = [
          ...state.mediaQualityAssuranceSettings,
          action.payload,
        ]
      }
    },
    set_mediaQualityAssuranceSettings: (state, action) => {
      let { key, value, id } = action.payload
      state.mediaQualityAssuranceSettings =
        state.mediaQualityAssuranceSettings.map((item) => {
          if (item && item.id === id) {
            return {
              ...item,
              [key]: value,
            }
          }
          return item
        })
    },
  },
  extraReducers: (builder) => {
    builder.addCase('LOGOUT', () => {
      return { ...initialState }
    })

    builder.addCase(
      LoadMediaQualityAssuranceSettingssAsync.pending,
      (state) => {
        state.is_loading_mediaQualityAssuranceSettings = true
      },
    )
    builder.addCase(
      LoadMediaQualityAssuranceSettingssAsync.fulfilled,
      (state, action) => {
        state.is_loading_mediaQualityAssuranceSettings = false
        if (action.payload) {
          state.mediaQualityAssuranceSettings = action.payload
        }
      },
    )
    builder.addCase(
      LoadMediaQualityAssuranceSettingssAsync.rejected,
      (state) => {
        state.is_loading_mediaQualityAssuranceSettings = false
      },
    )
    builder.addCase(
      CreateMediaQualityAssuranceSettingsAsync.pending,
      (state) => {
        state.is_creating_mediaQualityAssuranceSettings = true
      },
    )
    builder.addCase(
      CreateMediaQualityAssuranceSettingsAsync.fulfilled,
      (state) => {
        state.is_creating_mediaQualityAssuranceSettings = false
      },
    )
    builder.addCase(
      CreateMediaQualityAssuranceSettingsAsync.rejected,
      (state) => {
        state.is_creating_mediaQualityAssuranceSettings = false
      },
    )
    builder.addCase(
      DeleteMediaQualityAssuranceSettingsAsync.pending,
      (state) => {
        state.is_deleting_mediaQualityAssuranceSettings = true
      },
    )
    builder.addCase(
      DeleteMediaQualityAssuranceSettingsAsync.fulfilled,
      (state, action) => {
        state.is_deleting_mediaQualityAssuranceSettings = false
        if (state.mediaQualityAssuranceSettings) {
          state.mediaQualityAssuranceSettings =
            state.mediaQualityAssuranceSettings.filter(
              (x) => action.payload.id !== x.id,
            )
        }
      },
    )
    builder.addCase(
      DeleteMediaQualityAssuranceSettingsAsync.rejected,
      (state) => {
        state.is_deleting_mediaQualityAssuranceSettings = false
      },
    )
  },
})

export const {
  clearStatemediaQualityAssuranceSettings,
  setSelectedmediaQualityAssuranceSettings,
  set_mediaQualityAssuranceSettings,
  mergemediaQualityAssuranceSettings,
  add_mediaQualityAssuranceSettings,
} = mediaQualityAssuranceSettingsSlice.actions

export const get_mediaQualityAssuranceSettings =
  (id?: string) =>
  (state: {
    mediaQualityAssuranceSettings: {
      mediaQualityAssuranceSettings: MediaQualityAssuranceSettings[]
    }
  }): MediaQualityAssuranceSettings | null => {
    let temp =
      state?.mediaQualityAssuranceSettings?.mediaQualityAssuranceSettings?.find(
        (v) => v.id === id,
      )
    if (temp) {
      return temp
    }
    return (
      state?.mediaQualityAssuranceSettings?.mediaQualityAssuranceSettings[0] ||
      null
    )
  }
export const get_selected_mediaQualityAssuranceSettings = (state: {
  mediaQualityAssuranceSettings: mediaQualityAssuranceSettingsSliceState
}): MediaQualityAssuranceSettings | null => {
  let id =
    state?.mediaQualityAssuranceSettings?.selected_mediaQualityAssuranceSettings
  let temp =
    state?.mediaQualityAssuranceSettings?.mediaQualityAssuranceSettings?.find(
      (v) => v.id === id,
    )
  if (temp) {
    return temp
  }
  return null
}
export const get_all_mediaQualityAssuranceSettings = (state: {
  mediaQualityAssuranceSettings: {
    mediaQualityAssuranceSettings: MediaQualityAssuranceSettings[]
  }
}): MediaQualityAssuranceSettings[] => {
  let temp = state?.mediaQualityAssuranceSettings?.mediaQualityAssuranceSettings
  if (temp) {
    return temp.filter((x) => !x.deleted)
  }
  return []
}
export const is_mediaQualityAssuranceSettings_busy = (state: {
  mediaQualityAssuranceSettings: mediaQualityAssuranceSettingsSliceState
}) => {
  return (
    state?.mediaQualityAssuranceSettings
      .is_deleting_mediaQualityAssuranceSettings ||
    state?.mediaQualityAssuranceSettings
      .is_loading_mediaQualityAssuranceSettings ||
    state?.mediaQualityAssuranceSettings
      .is_creating_mediaQualityAssuranceSettings
  )
}
export const is_deleting_mediaQualityAssuranceSettings_busy = (state: {
  mediaQualityAssuranceSettings: mediaQualityAssuranceSettingsSliceState
}) => {
  return state?.mediaQualityAssuranceSettings
    .is_deleting_mediaQualityAssuranceSettings
}
export const is_loading_mediaQualityAssuranceSettings_busy = (state: {
  mediaQualityAssuranceSettings: mediaQualityAssuranceSettingsSliceState
}) => {
  return state?.mediaQualityAssuranceSettings
    .is_loading_mediaQualityAssuranceSettings
}
export const is_creating_mediaQualityAssuranceSettings_busy = (state: {
  mediaQualityAssuranceSettings: mediaQualityAssuranceSettingsSliceState
}) => {
  return state?.mediaQualityAssuranceSettings
    .is_creating_mediaQualityAssuranceSettings
}

export default mediaQualityAssuranceSettingsSlice.reducer
